<template>
  <div class="container">
    <header>
      <van-image width="100%" :src="require('@/assets/jyhd-bj@3x.png')"/>
    </header>
    <section class="activity" v-if="activityList || activityList.length">
      <van-image class="activity-title" :src="require('@/assets/jyhd-dabiao@3x.png')"/>
      <template v-for="item of activityList.slice(0,1)">
        <div class="item" :key="item.id" @click="goToSignUp(item.id)">
          <van-image class="img" :src="item.coverImage"/>
          <div class="info">
            <h4 class="van-multi-ellipsis--l2">{{ item.title }}</h4>
            <p class="van-ellipsis" style="margin-bottom: 10px">活动时间：{{ item.activityTime }}</p>
            <p class="van-ellipsis">活动地点：{{ item.gatherSignLocation }}</p>
          </div>
        </div>
      </template>
      <div class="no-move" v-if="activityList.length === 0">
        <img src="@/assets/moren@2x.png" alt="">
        <p>报名尚未开始，敬请期待</p>
      </div>
      <router-link v-if="activityList.length !== 0" class="readmore" to="/educational/activityRegistration">
        查看更多
        <van-icon name="arrow"/>
      </router-link>
      <div class="Divider"><img src="@/assets/jyhd-biao1@3x.png" alt=""></div>
    </section>
    <!--    对方的报名系统-- 开始 -->
<!--    <section class="activity" v-if="activityList || activityList.length">-->
<!--      <van-image class="activity-title" :src="require('@/assets/jyhd-dabiao@3x.png')"/>-->
<!--      <template v-for="item of activityList">-->
<!--        <div class="item" :key="item.id" @click="goToSignUp2(item.id)">-->
<!--          <van-image class="img" :src="item.coverImage"/>-->
<!--          <div class="info">-->
<!--            <h4 class="van-multi-ellipsis&#45;&#45;l2">{{ item.title }}</h4>-->
<!--            <p class="van-ellipsis" style="margin-bottom: 10px">活动时间：{{ item.activityTime }}</p>-->
<!--            <p class="van-ellipsis">活动地点：{{ item.gatherSignLocation }}</p>-->
<!--          </div>-->
<!--        </div>-->
<!--      </template>-->
<!--      <div class="no-move" v-if="activityList.length === 0">-->
<!--        <img src="@/assets/moren@2x.png" alt="">-->
<!--        <p>报名尚未开始，敬请期待</p>-->
<!--      </div>-->
<!--      <router-link class="readmore" to="/educational/activityRegistration2">-->
<!--        查看更多-->
<!--        <van-icon name="arrow"/>-->
<!--      </router-link>-->
<!--      <div class="Divider"><img src="@/assets/jyhd-biao1@3x.png" alt=""></div>-->
<!--    </section>-->
    <!--    对方的报名系统-- 结束 -->
    <section class="classroom">
      <van-image class="classroom-title" :src="require('@/assets/jyhd-dabiao-1@3x.png')"/>
      <div class="list">
        <template v-for="(item, index) of classroom.slice(0,6)">
          <div @click="videoClick(item)" class="item" :key="index">
            <div style="visibility:hidden" class="type"><span>手绘视频</span></div>
            <van-image class="img" fit="cover" :src="item.coverImage"/>
            <div class="title">{{ item.title }}</div>
          </div>
        </template>
      </div>
      <router-link class="readmore" to="/educational/classroom">
        查看更多内容
        <van-icon name="arrow"/>
      </router-link>
      <div class="Divider"><img src="@/assets/jyhd-biao1@3x.png" alt=""></div>
    </section>
    <section class="review" style="padding-top: 0">
      <van-image class="review-title" :src="require('@/assets/jyhd-dabiao-2@3x.png')"/>
      <template v-for="(item, index) of historys.slice(0,6)">
        <div @click="wqClick(item)" :key="index">
          <div class="item">
            <van-image class="img" fit="cover" :src="item.coverImage"/>
            <div class="info">
              <h4 class="van-multi-ellipsis--l2">{{ item.title }}</h4>
              <!--              <p class="van-ellipsis">活动时间：{{item.activityTime}}</p>-->
              <!--              <p class="van-ellipsis">活动地点：{{item.activityLocation}}</p>-->
            </div>
          </div>
          <!--          <van-divider v-if="index !== reviewList.length - 1" hairline :style="{ borderColor: '#312925', margin: '16px 0 12px' }" />-->
        </div>
      </template>
    </section>
    <!--    <van-divider hairline :style="{ borderColor: '#312925', margin: '16px 0 12px' }" />-->
    <router-link class="readmore" style="padding-bottom: 10px" to="/educational/review">
      查看更多内容
      <van-icon name="arrow"/>
    </router-link>
  </div>
</template>

<script>
import { getActivities, getPbEducationHistory, getPbEducationOnlineClass } from '@/api/educational'

export default {
  name: 'Educational',
  data: () => ({
    activityList: [],
    reviewList: [{}, {}],
    classroom: [],
    historys: []
  }),
  created () {
    this.getActivities()
    this.getClassroom()
    this.review()
  },
  methods: {
    async getActivities () {
      const { result } = await getActivities()
      console.log(result)
      this.activityList = result
    },
    async getClassroom () {
      const { result } = await getPbEducationOnlineClass({
        pageNo: 1
      })
      console.log(result)
      this.classroom = result.records
    },
    async review () {
      const { result } = await getPbEducationHistory({
        pageNo: 1
      })
      console.log(result.records)
      this.historys = result.records
    },
    goToSignUp (id) {
      this.$router.push({
        path: '/educational/signup',
        query: { id }
      })
    },
    goToSignUp2 (id) {
      this.$router.push({
        path: '/educational/signup2',
        query: { id }
      })
    },
    videoClick (item) {
      window.location.href = item.video
    },
    wqClick (item) {
      console.log(item)
      window.location.href = item.content
    }
  }
}
</script>

<style lang="scss" scoped>
::-webkit-scrollbar {
  display: none;
}

.Divider {
  margin-top: 13px;

  img {
    width: 100%;
  }
}

.readmore {
  display: block;
  text-align: center;
  font-size: 15px;
  color: #253B41;
  margin-bottom: 27px;
}

.container {
  overflow: hidden;
  min-height: 100vh;
  background-color: #EEECEA;
  padding-bottom: constant(safe-area-inset-bottom); /* 兼容 iOS < 11.2 */
  padding-bottom: env(safe-area-inset-bottom); /* 兼容 iOS >= 11.2 */
  header {
    text-align: right;

    .educational-icon {
      position: absolute;
      top: 120px;
      left: 20px;
      width: 120px;
    }
  }

  .pattern-center {
    position: absolute;
    top: 383px;
    left: 0;
  }

  section {
    &.activity {
      margin-top: -40px;
      //background: linear-gradient(0deg, rgba(93, 66, 37, .3), rgba(93, 66, 37, 0.3), rgba(93, 66, 37, 0.3));
      padding: 20px 20px 15px;
      padding-bottom: 0;

      .activity-title {
        width: 159px;
        display: block;
        margin: 37px auto 20px;
      }

      .no-move {
        text-align: center;

        img {
          width: 121px;
        }

        p {
          font-size: 14px;
          font-weight: 400;
          color: #BCB1AE;
        }
      }

      .item {
        display: flex;
        //align-items: center;
        width: 100%;
        margin-bottom: 30px;

        .img {
          width: 120px;
          height: 100px;
          border-radius: 4px;
          overflow: hidden;
          object-fit: cover;
        }

        .info {
          flex: 1;
          overflow: hidden;
          margin-left: 10px;

          h4 {
            width: 100%;
            font-size: 16px;
            line-height: 1.3;
            color: #392F29;
            margin: 0 0 6px;
            margin-bottom: 17px;
            font-family: 'PingFangBold';
          }

          p {
            font-size: 14px;
            margin: 5px 0 0;
            font-weight: 400;
            color: #666666;

            &:nth-of-type(1) {
              margin-top: 0;
            }
          }
        }
      }
    }

    &.classroom {
      margin-left: 20px;
      margin-bottom: 30px;

      .classroom-title {
        width: 159px;
        display: block;
        margin: 24px auto 20px;
      }

      .list {
        white-space: nowrap;
        overflow-y: scroll;
        margin-bottom: 30px;
      }

      .item {
        vertical-align: top;
        width: 123px;
        border: 1px solid #312925;
        border-radius: 4px;
        overflow: hidden;
        display: inline-block;
        margin-right: 10px;
        background-color: #6A8D99;

        .type {
          color: #EFECEC;
          display: block;
          font-size: 12px;
          font-weight: 500;
          white-space: normal;

          span {
            display: inline-block;
            background-color: #253B41;
            line-height: 1.2;
            border-radius: 4px 0px 4px 0px;
            padding: 2px 4px;
          }
        }

        .img {
          width: 100%;
          height: 100px;
          padding: 0 10px;
          box-sizing: border-box;
          border-radius: 2px;
          overflow: hidden;
          object-fit: cover;
          white-space: normal;
        }

        .title {
          margin-top: 11px;
          height: 40px;
          line-height: 1.6;
          background: #D1D6D8;
          color: #526065;
          font-size: 14px;
          text-align: center;
          padding: 5px 0;
          white-space: normal;
          overflow: hidden;
          text-overflow: ellipsis;
          display: -webkit-box;
          -webkit-line-clamp: 2;
          line-clamp: 2;
          -webkit-box-orient: vertical;
        }
      }
    }

    &.review {
      padding: 20px 20px 15px;

      .review-title {
        width: 159px;
        display: block;
        margin: 0 auto 20px;
      }

      .item {
        display: flex;
        //align-items: center;
        width: 100%;
        margin-bottom: 20px;

        .img {
          width: 120px;
          height: 100px;
          border-radius: 4px;
          overflow: hidden;
          object-fit: cover;
        }

        .info {
          flex: 1;
          overflow: hidden;
          margin-left: 10px;

          h4 {
            width: 100%;
            font-size: 16px;
            line-height: 1.3;
            color: #392F29;
            margin: 0 0 6px;
            margin-bottom: 17px;
            font-family: 'PingFangBold';
          }

          p {
            font-size: 14px;
            margin: 5px 0 0;
            font-weight: 400;
            color: #666666;

            &:nth-of-type(1) {
              margin-top: 0;
            }
          }
        }
      }
    }
  }
}
</style>
